var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"LandingNotes"},[_c('div',{staticClass:"LandingNotes__string",domProps:{"innerHTML":_vm._s(_vm.content.string + '&nbsp;&nbsp;|&nbsp;&nbsp;'+_vm.content.notes)}})])}
var staticRenderFns = []

export { render, staticRenderFns }